export var heatmap = function () { return ({
    name: 'heatmap',
    setup: function (client) {
        var getExports = function (code) {
            var module = { exports: {} };
            // eslint-disable-next-line
            var fn = new Function('module', 'exports', code);
            try {
                fn(module, module.exports);
                return module.exports;
            }
            catch (err) {
                return {};
            }
        };
        function request(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.onload = function (e) {
                var response = e.target.response;
                response && callback(response);
            };
            xhr.send();
        }
        var HEATMAP_MONITOR_PLUGIN_NAME = 'heatmap';
        client.on('start', function () {
            var _a;
            var heatmapConfig = (_a = client.config()) === null || _a === void 0 ? void 0 : _a.plugins[HEATMAP_MONITOR_PLUGIN_NAME];
            if (!heatmapConfig) {
                return;
            }
            var open_list = heatmapConfig.open_list, url = heatmapConfig.url;
            if (!url) {
                return;
            }
            var heatmap;
            var callback = function (res) {
                var createHeatmap = getExports(res).createHeatmap;
                if (!createHeatmap) {
                    return;
                }
                var config = {
                    open_list: open_list,
                };
                heatmap = createHeatmap({
                    config: config,
                    sendEvent: function (args) { return client.report(args); },
                });
                heatmap.init();
            };
            request(url, callback);
            var tearDown = function () {
                heatmap === null || heatmap === void 0 ? void 0 : heatmap.destroy();
            };
            client.on('beforeDestroy', tearDown);
        });
    },
}); };
//# sourceMappingURL=heatmap.js.map